import { useEffect } from 'react';

const useHideBotmarker = hide => {
  useEffect(() => {
    const iframes = document.querySelectorAll('iframe');
    if (hide) {
      if (iframes) {
        iframes.forEach(d => {
          if (d.getAttribute('name') === 'Botmaker') {
            d.parentNode.style.display = 'none';
          }
        });
      }
    } else if (iframes) {
      iframes.forEach(d => {
        if (d.getAttribute('name') === 'Botmaker') {
          d.parentNode.style.display = 'block';
        }
      });
    }
  }, [hide]);
};

export default useHideBotmarker;
